import { IAdminChecklistFullnessType } from 'APIPackage/AdminModule/interfaces/IAdminChecklistFullnessType';

import { IChecklistFullnessTypeSelectOption } from '../interfaces/IChecklistFullnessTypeSelectOption';

export function createChecklistFullnessTypesSelectOption(
  type: IAdminChecklistFullnessType,
): IChecklistFullnessTypeSelectOption {
  return {
    ...type,
    label: type.name,
    value: type.code,
  };
}
